import { Log } from "@/interfaces/Log.ts";
import { PaginatedResponse } from "@/interfaces/paginatedResponse.ts";
import axios from "@/lib/axios.ts";
import { useLogsStore } from "@/stores/Log.ts";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { storeToRefs } from "pinia";
import { watch } from "vue";

interface Params {
  id: string | number;
  page?: number | string;
}

interface Props {
  immediate: boolean;
  params: Params;
}

const getUserLog = async (params: Params): Promise<PaginatedResponse<Log>> => {
  const { data } = await axios.get<PaginatedResponse<Log>>(
    `/api/users/${params.id}/logs?page=${params.page}`,
  );

  return data;
};

const useUserLog = (props: Props) => {
  const { immediate = true, params } = props;

  const { logs, pagination, page } = storeToRefs(useLogsStore());
  const { setLog, setPage, setPagination } = useLogsStore();

  const { data, isLoading, refetch } = useQuery(
    ["userLog", params.id],
    () =>
      getUserLog({
        id: params.id,
        page: page.value,
      }),
    {
      enabled: immediate,
    },
  );

  watch(
    data,
    (value) => {
      if (value) {
        setLog(value.data);
        setPagination(_.omit(value, ["data"]));
      }
    },
    {
      immediate,
    },
  );

  return {
    logs,
    page,
    pagination,
    isLoading,

    setPage,
    refetch,
  };
};

export default useUserLog;
